import { render, staticRenderFns } from "./Criterias.vue?vue&type=template&id=5166a80c&"
import script from "./Criterias.vue?vue&type=script&lang=js&"
export * from "./Criterias.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports